export const ROUTES = {
    HOME_DEFAULT: '*',
    HOME: '/',
    WELCOME: "/Welcome",
    PATIENT: "/Patient",
    PATIENT_DETAILS: "/Patientdetails",
    PARTY_REQUEST: "/Partyrequest",
    SINGLE_REQUEST: "/Singlerequest",
    BULK_REQUEST: "/Bulkrequest",
    THANKS: "/Thanks",
    REQUIREMENT: "/Requirement",
    PATIENT_DETAILS_FMLA: "/PatientdetailsFMLA",
    TEST_CLIENT: "/testClient",
    FEEDBACK: "/Feedback",
    FEEDBACK_THANKS: "/FeedbackThanks",
    DOCUMENT: "/doc",
    DOCUMENT_ERROR: "/doc-error",
}